<template id="challenge-card-signup">
    <div class="sign-up">
        <a v-bind:href="getSignUpUrl" class="btn">Sign Up!</a>
    </div>
</template>

<script>
export default {
  template: '#challenge-card-signup',
  props: ['signUpUrl'],
  computed: {
    getSignUpUrl: function() {
      return window.location.origin + this.signUpUrl
    }
  }
}
</script>
